import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { SettingService } from '../../../../core/services/setting.service';
import { AuthService } from '../../../../modules/auth/services/auth.service';
import { AppUtils } from '../../../../core/config/app.utils';
import { ActionAlert } from '../../../../core/dto/actionAlert';
import { LoadingService } from '../../../../core/services/loading.service';

@Component({
  selector: 'app-pref-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
})
export class PrefNotificationsComponent implements OnInit {
  brand: any;
  brandId: any;
  notificationForm: any;
  itineraryViewNotificationForm: any;
  loggedUser: any;
  formErrors: any = {
    emails: {},
    isTourConfirmationEnabled: {},
    isAttachItinerary: {},
  };
  actionMessage = new ActionAlert();
  msg = '';

  constructor(
    private fb: FormBuilder,
    private settingService: SettingService,
    private authService: AuthService,
    private loading: LoadingService,
    private translocoService: TranslocoService
  ) {}

  ngOnInit(): void {
    this.loading.start();
    this.loggedUser = this.authService.getLoggedInUser();
    this.findBrand().then(r => {
      this.loading.stop();
    });
    this.notificationForm = this.fb.group({
      emails: [[], [this.emailValidator]],
      isTourConfirmationEnabled: [false],
      isAttachItinerary: [false, [Validators.required]],
      isB2bItineraryLinkEnabled: [true],
    });
    this.itineraryViewNotificationForm = this.fb.group({
      toNotifySuperAdmin: [false],
      toNotifyCreator: [false],
    });
    this.notificationForm.valueChanges.subscribe((form: any) => {
      AppUtils.getFormErrors(this.notificationForm, this.formErrors);
    });

    this.notificationForm
      .get('isTourConfirmationEnabled')
      .valueChanges.subscribe((isTourConfirmationEnabled: boolean) => {
        if (isTourConfirmationEnabled) {
          this.notificationForm
            .get('emails')
            .addValidators(Validators.required);
        } else {
          this.notificationForm.get('emails').reset();
        }

        this.notificationForm.get('emails').updateValueAndValidity();
      });
  }

  async findBrand(): Promise<void> {
    this.brand = await this.settingService.findBrand(this.loggedUser.userId);
    this.brandId = this.brand._id;
    this.notificationForm.patchValue(this.brand?.notification || {});
    this.itineraryViewNotificationForm.patchValue(
      this.brand?.itineraryViewNotification || {}
    );
  }

  emailValidator = (control: FormControl) => {
    let isEmail = false;
    control?.value?.forEach((val: any) => {
      const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      if (!regex.test(val as string)) {
        isEmail = true;
      }
    });
    if (isEmail) {
      return { email: true };
    } else {
      return {};
    }
  };
  async updateBrand(msg: string): Promise<void> {
    try {
      this.loading.start();
      const payload = {
        _id: this.brandId,
        notification: this.notificationForm.getRawValue(),
        itineraryViewNotification:
          this.itineraryViewNotificationForm.getRawValue(),
      };
      await this.settingService.updateBrand(payload);
      this.msg = msg;
      this.actionMessage = new ActionAlert(
        true,
        true,
        this.translocoService.translate(
          'settings.preferences.notifications.messages.updated'
        ),
        'success'
      );
      this.loading.stop();
    } catch (e) {
      this.actionMessage = new ActionAlert(
        true,
        true,
        this.translocoService.translate(
          'settings.preferences.notifications.messages.notUpdated'
        ),
        'error'
      );
      this.loading.stop();
    }
  }
}
